import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { DialogActions, useTheme } from '@mui/material';
import { MarketButton, MarketHeader } from '@market/react';
import { useOrderDetails } from 'components/context/order_details';
import {
  onCheckoutPageClick,
  pushHistoryWithSearchParams,
  CHECKOUT_PAGE_CLICK_EVENTS,
} from 'components/pages/checkout/utilities';

const Reviewed = () => {
  const theme = useTheme();
  const history = useHistory();
  const { t } = useTranslation();
  const { trackingData } = useOrderDetails();

  return (
    <>
      <MarketHeader style={{ margin: theme.spacing(4, 4, 0) }}>
        <h1>{t('checkout.financeApp.modals.reviewed.title')}</h1>
      </MarketHeader>
      <DialogActions sx={{ px: 4, py: 4 }}>
        <MarketButton
          id="continue-btn"
          rank="primary"
          onClick={() => {
            onCheckoutPageClick({
              eventDesc: CHECKOUT_PAGE_CLICK_EVENTS.financing_approved,
              trackingData,
              componentName: 'Financing Application',
              actionItem: 'continue_to_payment',
            });
            pushHistoryWithSearchParams(history, '/payment');
          }}
          style={{ width: '100%' }}
        >
          {t('common.continue')}
        </MarketButton>
      </DialogActions>
    </>
  );
};

export default Reviewed;
